import { PhotoWorkerManager } from '@incube8/photo-worker';
import { logException } from './helpers';

const photoWorkerManager = new PhotoWorkerManager({
  batchSize: 5,
});

export const processFiles = async files => {
  return await photoWorkerManager.processFiles(files);
};

export const closePhotoWorker = () => {
  photoWorkerManager.done();
};

export const getFileExtension = (filename: string) => {
  const parts = filename.split('.');

  return parts.length > 1 ? parts[parts.length - 1].split('-')[0] : ''; // returns the last part after the dot
};

export const uploadPhotoToS3 = async (formData: any, photoResponse: any): Promise<void> => {
  try {
    await photoWorkerManager.uploadFile({
      id: photoResponse.data.path,
      image: formData.photoFile,
      isCropped: formData.isCropped,
      uploadUrl: photoResponse.meta.uploadUrl,
    });
  } catch (error) {
    logException(
      `Bulk Photo upload error - Failed to upload photo to S3`,
      { photoUpload: error.message, formData, photoResponse },
      'info'
    );
    throw error;
  }
};
